import GenericForm from 'components/GenericForm';
import type { GenericFormFields, SitecoreBlockProps } from 'models/sitecore';

interface Props extends SitecoreBlockProps {
	fields?: GenericFormFields;
}

export default function QuestionsAndAnswersForm({ fields }: Props) {
	if (!fields) {
		return null;
	}

	return (
		<GenericForm
			formLocation="QuestionsAndAnswersForm"
			sections={fields.sections}
			errorView={fields.error}
			successView={fields.success}
			loadingView={fields.loading}
		/>
	);
}
QuestionsAndAnswersForm.displayName = 'QuestionsAndAnswersForm_Partial';
